<template>
  <b-modal
    id="modal-security-answer"
    hide-footer
    centered
    size="lg"
    :noCloseOnBackdrop="true"
    :noCloseOnEsc="true"
    :hideHeaderClose="true"
  >
    <div
      class="col-12 d-flex flex-column align-items-center p-0"
      style="position: relative; z-index: 1"
    >
      <img
        class="centerImg1"
        src="@/assets/images/icons/alert-line.svg"
        width="20%"
      />
      <h3 class="pt-3 font-weight-bold mb-4">Pregunta de seguridad</h3>
      <b-alert show variant="warning" class="alert-warning-message">
        <div class="d-flex">
          <div class="mr-3">
            <img
              src="@/assets/images/icons/alert-line.svg"
              alt=""
              width="28px"
              height="28px"
            />
          </div>
          <p style="font-size: 14px; color: #263238; margin-bottom: 0">
            Para continuar responde la siguiente pregunta de seguridad
          </p>
        </div>
      </b-alert>

      <div class="w-100">
        <b-overlay :show="loading" rounded="sm">
          <template #overlay>
            <OverlayButton clase="overlay-md"> </OverlayButton>
          </template>
          <div class="row w-100 mt-5">
            <b-col cols="12">
              <Input
                :label="question?.name"
                :name="`question-answer`"
                :value="formData.answer"
                :required="true"
                @input="(event) => (formData.answer = event.target.value)"
              />
            </b-col>
            <b-col>
              <button
                class="btn-change-question"
                @click.prevent="ramdomQuestion()"
              >
                Cambiar pregunta
              </button>
            </b-col>
          </div>
        </b-overlay>
      </div>
      <div
        class="w-100 mt-4 d-flex align-content-center justify-content-center"
        v-if="!loading"
      >
        <button
          class="button_primary"
          @click.prevent="saveValidate()"
          :disabled="isBusy || validateAnswer"
        >
          <span class="cta">Validar Respuesta</span>
          <b-spinner v-if="isBusy" />
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import securitySevices from "@/services/legal/security/service.js";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";

import useInputs from "@/components/general/Inputs";

const { Input } = useInputs();
export default {
  props: {
    isInactive: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Input,
    OverlayButton,
  },
  data() {
    return {
      isBusy: false,
      loading: true,
      questions: [],
      formData: {
        question_id: null,
        answer: "",
      },
      question: null,
    };
  },
  watch: {
    isInactive() {
      const me = this;
      if (me.isInactive) me.loadListSecurityAnswers();
    },
  },
  computed: {
    validateAnswer() {
      const me = this;
      let result = false;
      if (me.formData.answer == "") result = true;
      return result;
    },
  },
  methods: {
    async loadListSecurityAnswers() {
      const me = this;
      me.loading = true;
      try {
        const { data } = await securitySevices.getMyQuestions();
        data?.forEach((item) => {
          me.questions.push({
            id: item.id,
            name: item.question,
          });
        });
        console.log(me.questions);
        me.ramdomQuestion();
      } catch (error) {
        console.log(error);
      } finally {
        me.loading = false;
      }
    },
    async saveValidate() {
      const me = this;
      me.isBusy = true;
      try {
        const { data } = await securitySevices.validateAnswer(me.formData);
        if (data?.is_blocked) {
          me.$emit("onBlocked");
        } else if (data?.is_correct) {
          me.$emit("onSuccess", "Respuesta correcta, puede continuar");
        } else {
          me.$emit(
            "onError",
            `Respuesta incorrecta, te quedan ${data?.attempts} intento(s).`
          );
          me.formData.answer = "";
        }
      } catch (error) {
        me.$emit("onError", "Error respuesta incorrecta");
      } finally {
        me.isBusy = false;
      }
    },
    ramdomQuestion() {
      const me = this;
      me.formData.answer = "";
      me.question =
        me.questions[Math.floor(Math.random() * me.questions.length)];
      me.formData.question_id = me.question?.id;
    },
  },
};
</script>

<style lang="css" scoped>
.btn-change-question {
  border: none;
  background-color: transparent;
  color: #5d5fef;
}
</style>
